import { render, staticRenderFns } from "./MarketplaceChallanEdit.vue?vue&type=template&id=5d2c1867&scoped=true&"
import script from "./MarketplaceChallanEdit.vue?vue&type=script&lang=js&"
export * from "./MarketplaceChallanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c1867",
  null
  
)

export default component.exports